<template>
  <div>
    <div class="card">
      <h1>Informations et liens utiles</h1>
      <div class="links-part">
        <router-link to="/app"><div class="info-link">Télécharger l'application</div></router-link>
        <router-link to="/contact"><div class="info-link">Nous contacter</div></router-link>
        <router-link to="/bug"><div class="info-link">Signaler un bug</div></router-link>
        <router-link to="/privacy"><div class="info-link">Politique de confidentialité</div></router-link>
        <router-link to="/cgu"><div class="info-link">Mentions légales</div></router-link>
      </div>
      <img id="img-illustration" src="../assets/illustration-tnoir.png" alt="Illustration SV Quiz">
    </div>
  </div>
</template>


<style scoped>
  .card {
    width: 70%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  h1 {
    font-size: 30px;
    margin: 0 0 30px;
    text-align: center;
  }
  .links-part {
    text-align: center;
  }
  .info-link {
    color: var(--color-text-1);
    transition: var(--transition-duration-color);
    cursor: pointer;
    padding: 6px 0;
  }
  .info-link:hover {
    text-decoration: underline;
  }
  #img-illustration {
    margin-top: 10px;
    width: 30%;
    opacity: .3;
  }


  @media screen and (max-width: 1400px) {
    .card {
      width: 85%;
    }
  }
  @media screen and (max-width: 720px) {
    .card {
      width: 96%;
    }
  }
</style>
<script>
export default {
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>